import {EnvironmentProviders, inject, provideAppInitializer} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

const svgNamesFromMonolith = [
  'add',
  'add-widget',
  'arrow-left',
  'bank',
  'bookmark',
  'bookmark_selected',
  'building',
  'chevron-down-white',
  'chevron-down-default',
  'chevron-right',
  'chevron-left',
  'chevron-up-white',
  'chevron-up',
  'chevron-down',
  'clock',
  'close-item-small',
  'close',
  'contacts',
  'currency-usd',
  'database',
  'deals',
  'download',
  'edit',
  'error-warning',
  'file-edit-outline',
  'google_icon',
  'help-icon',
  'history',
  'intel',
  'launch',
  'log-out',
  'linkedin-logo',
  'mail',
  'map-pin',
  'menu',
  'more-vertical',
  'nav-help',
  'overview',
  'open-in-new',
  'phone',
  'pipeline-report',
  'plus',
  'plus_grey',
  'reports',
  'refresh',
  'Reminder-completion',
  'Reminder-active',
  'search',
  'search-blue',
  'settings',
  'shield-check',
  'sliders',
  'star-filled',
  'star-outlined',
  'open-in-new',
  'account-check',
  'upload',
  'trash',
  'radio-blank',
  'radio-checked',
  'auto-calculate',
  'selected_offer',
  'MDI-trophy-variant',
  'status-default',
  'status-done',
  'verified-check',
  'check-outline',
  'checkbox-marked-circle-outline',
  'dollar',
  'add-to-contact-list',
  'add-to-deal',
  'remove-from-deal',
  'assign-broker',
  'add-activities',
  'company-icon',
  'comments-icon',
  'ideal-icon',
  'company-primary-contact',
  'transaction-management',
  'add-activity',
  'search-new',
  'bank-plus',
  'warning',
  'MDI-sort',
  'MDI-filter-menu-outline',
  'Notification',
  'Notification_ON',
  'MarkAsRead',
  'no-notifications',
  'Sharepoint-icon',
  'email-send-outline',
  'key-member',
  'lock-icon',
  'add-activity',
  'filter-icon',
  'smart-match-suggestion'

];

const svgNamesFromLocalAssets = [
  'merge',
  'external-link',
  'campaign',
  'RCM-logo',
  'Buildout-logo',
  'Buildout-logo--small',
  'newmark_nim_export',
  'newmark-investor-marketplace',
  'nim-bar-chart-square',
  'nim-file',
  'nim-send',
  'nim-globe',
  'nim-browser-listing',
  'nim-edit-listing',
  'nim-dealroom',
  'lock',
  'globe',
  'email-receive-outline',
  'filter',
  'filter_filled',
  'expand',
  'collapse',
  'edit_square',
  'undo',
  'redo',
  'list-group',
  'file-lock-outline',
  'tip',
  'arrow-right-bottom',
  'buydown',
  'email-send-outline',
  'otbe-chip',
  'company',
  'handshake',
  'company_contacts',
  'landmark',
  'verified-custom-shape',
  'verified-custom-shape-outlined',
  'unverified-custom-shape',
  'hierarchy',
  'comp-name-match',
  'comp-tree-match',
  'smart-match-sparkle',
  'share',
  'stars',
  'box-logo'
];

export const customIconInitProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = ((registry: MatIconRegistry, sanitizer: DomSanitizer) => () => {
    svgNamesFromLocalAssets.forEach((name) => {
      const path = `assets/icons/${name}.svg`;
      registry.addSvgIcon(
        name,
        sanitizer.bypassSecurityTrustResourceUrl(path),
      );
    });
    svgNamesFromMonolith.forEach((name) => {
      const path = `assets/images/svg/${name}.svg`;
      registry.addSvgIcon(
        name,
        sanitizer.bypassSecurityTrustResourceUrl(path),
      );
    });
  })(inject(MatIconRegistry), inject(DomSanitizer));
  return initializerFn();
});
